require("@rails/ujs").start();
require("turbolinks").start();
window.Cookies = require("js-cookie");
window.tippy = require('tippy.js').default;
require("packs/global/toggle-tile.js");
require("packs/global/load-ranking-account-details.js");
require("packs/global/menu.js");
Menu.init();
require("packs/global/tippy.js");
Tippy.init();
require("packs/global/bulma-message.js");
BulmaMessage.init();
require("packs/global/js-load.js");
JsLoad.init();
require("packs/global/comparison-tool.js");
ComparisonTool.init();
require("packs/global/scroll-lock.js");
require("packs/global/remote-ujs.js");
require("packs/global/comments.js");
require("packs/global/js-link.js");
require("packs/global/conversion-tracking.js");
require("packs/global/modal.js");
require("packs/global/exit-intent-popup.js");
ExitIntentPopup.init();
require("packs/global/recaptcha.js");
